var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useRestrictiveNumberHandlers } from '../hooks/useRestrictiveNumberHandlers';
import { InputItem } from '../internals/InputItem/InputItem';
export var NumberInput = function (_a) {
    var onlyInteger = _a.onlyInteger, onChange = _a.onChange, onKeyPress = _a.onKeyPress, _b = _a.restrictInput, restrictInput = _b === void 0 ? true : _b, rest = __rest(_a, ["onlyInteger", "onChange", "onKeyPress", "restrictInput"]);
    var _c = useRestrictiveNumberHandlers({
        onChange: onChange,
        onKeyPress: onKeyPress,
        onlyInteger: onlyInteger,
        restrictInput: restrictInput
    }), restrictedOnChange = _c[0], restrictedOnKeyPress = _c[1];
    return (React.createElement(InputItem, __assign({}, rest, { onChange: restrictedOnChange, onKeyPress: restrictedOnKeyPress, type: "number" })));
};
//# sourceMappingURL=NumberInput.js.map